module.exports = __webpack_public_path__ + "media/static/icons/icon-chevron-circle-right--white-3b17378afd8d00ad47f4781a1e207a5a.svg";